export function isLineItemUnassigned(li) {
  return !String(li?.task ?? li?.taskOverride ?? "").trim();
}

export function getInvoiceUnassignedCount(invoiceId, lineItems) {
  const idStr = invoiceId != null ? String(invoiceId) : "";
  if (!idStr) return 0;
  return (lineItems || []).filter(
    (li) => li.invoiceId != null && String(li.invoiceId) === idStr && isLineItemUnassigned(li)
  ).length;
}

export function getAssignmentProgress(lineItems) {
  const items = lineItems || [];
  const total = items.length;
  const assigned = items.filter((li) => !isLineItemUnassigned(li)).length;
  return { assigned, total };
}

export function findNextInvoiceWithUnassigned(sortedInvoices, lineItems, afterInvoiceId) {
  const list = sortedInvoices || [];
  const startIdx =
    afterInvoiceId != null
      ? list.findIndex((inv) => String(inv._id) === String(afterInvoiceId)) + 1
      : 0;
  for (let i = Math.max(0, startIdx); i < list.length; i += 1) {
    const inv = list[i];
    if (getInvoiceUnassignedCount(inv._id, lineItems) > 0) return inv;
  }
  return null;
}

export function findFirstInvoiceWithUnassigned(sortedInvoices, lineItems) {
  return findNextInvoiceWithUnassigned(sortedInvoices, lineItems, null);
}
